angular.
module("dx.webapp.routes").
controller("DxLiveViewRouteController", function LiveViewRouteController(
	$filter,
	$interval,
	$location,
	$rootScope,
	$routeParams,
	$scope,
	$timeout,

	DX_EXAMS_STEPS,
	DX_URLS,
	DX_SPELLCHECKSETTING,
	DX_STUDENT_SORT_PREDICATE,
	dxExam,
	dxExamsNavigator,
	dxRavenInterceptor,
	dxSorting,
	Exam,
	ExamRepository,
	examStatus,
	settingFlags,
	RoleTypeEnum,
	dxSession,
	DX_INVIGILATOR_SETTINGS,
	DX_INVIGILATOR_LOCATION_CONSTANTS,
	dxApi,
	NodeRepository,
	dxTime,

	dxDialog,
	dxLocalize,
	DX_KEY_CODES
) {
	"use strict";

	var self = this;

	self.dxExamsNavigator = dxExamsNavigator;
	self.DX_EXAMS_STEPS = DX_EXAMS_STEPS;

	self.dxSession = dxSession;
	self.RoleTypeEnum = RoleTypeEnum;
	self.DX_INVIGILATOR_SETTINGS = DX_INVIGILATOR_SETTINGS;
	self.DX_INVIGILATOR_LOCATION_CONSTANTS = DX_INVIGILATOR_LOCATION_CONSTANTS;

	self.reqs = {
		exam: false,
		progress: false,
		node: false,
	};

	self.studentProgress = [];
	self.questionCount = 0;
	self.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	self.unlockAllToggle = true;
	self.focusedRow = 0;
	self.DX_STUDENT_SORT_PREDICATE = DX_STUDENT_SORT_PREDICATE;

	// TODO: These needs to be updated to the correct url.
	self.lockExamsHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360022992293" :
		"https://support.digiexam.se/hc/en-us/articles/360022992293";

	self.studentFilter = {
		name: "",
		status: null,
	};

	self.orderStudentsBy = {
		predicate: DX_STUDENT_SORT_PREDICATE.FIRST_NAME,
		reverse: false,
	};

	self.filteredProgress = [];
	self.Urls = DX_URLS;
	self.dxApi = dxApi;
	self.studentSummary = {
		activeCount: 0,
		idleCount: 0,
		offlineCount: 0,
		traditionalCount: 0,
		absentCount: 0,
	};

	self.studentInformationColumns = 4;

	self.isPrintSubviewShown = false;

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	// Load exam and initialize stuff
	var examId = $routeParams.id != null ? parseInt($routeParams.id, 10) : 0; // eslint-disable-line eqeqeq, no-eq-null, no-negated-condition

	function onNodeLoadSuccess(node) {
		self.node = node;

		if (self.node.disabledStudentCodes) {
			self.studentInformationColumns = 3;
		}

		self.reqs.node = true;
	}

	self.setStudentsOrder = function setStudentsOrder(predicate) {
		var conf = self.orderStudentsBy;
		if (conf.predicate === predicate) {
			conf.reverse = !conf.reverse;
			self.studentProgress.reverse();
		} else {
			conf.predicate = predicate;
			conf.reverse = false;
			self.studentProgress = dxSorting.studentSort(self.studentProgress, conf);
		}
	};

	function updateSummary() {
		self.studentSummary.activeCount = 0;
		self.studentSummary.activeDoneCount = 0;
		self.studentSummary.absentCount = 0;
		self.studentSummary.traditionalCount = 0;
		self.studentSummary.idleCount = 0;
		self.studentSummary.offlineCount = 0;
		self.studentSummary.offlineDoneCount = 0;

		for (var i = 0; i < self.studentProgress.length; i++) {
			var sp = self.studentProgress[i];
			var c = self.getExamClass(sp);

			switch (c) {
				case "color-active":
					self.studentSummary.activeCount++;
					break;
				case "color-absent":
					self.studentSummary.absentCount++;
					break;
				case "color-traditional":
					self.studentSummary.traditionalCount++;
					break;
				case "color-idle":
					self.studentSummary.idleCount++;
					break;
				case "color-offline":
					self.studentSummary.offlineCount++;
					break;
				default:
					break;
			}

			if (sp.isDone) {
				switch (c) {
					case "color-active":
						self.studentSummary.activeDoneCount++;
						break;
					case "color-offline":
						self.studentSummary.offlineDoneCount++;
						break;
					default:
						break;
				}
			}
		}
	}

	$scope.$watch("vm.studentProgress", updateSummary, true);
	self.timerText = "";
	self.lastUpdatedProgressTime = null;
	self.timerDescription = "";
	self.forbidden = false;

	self.updateTimerText = function updateTimerText() {
		self.timerText = dxTime.elapsed(self.exam.start);
		self.timerDescription = dxLocalize.get("Elapsed");
	};

	self.updateLiveView = function updateLiveView() {
		updateProgress();

		if (self.exam.examStatus === examStatus.PLANNED) {
			ExamRepository.load(examId).then(function reloadExam(loadedExam) {
				self.exam = loadedExam;
			});
		}

		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			getInvigilatorSettings();
		}
	};

	function updateProgress() {
		var handledErrorCodes = [403, 404];

		dxApi.v1.exams.progress(self.exam.id, handledErrorCodes).then(function success(response) {
			self.reqs.progress = true;
			self.lastUpdatedProgressTime = new Date();
			self.questionCount = response.data.questionCount;
			if (response.data.studentsProgress) {
				self.copyStudentProgress(response.data.studentsProgress);
				handleRedactedPiiStudents();

				self.studentProgress = dxSorting.studentSort(self.studentProgress, self.orderStudentsBy);

				updateSummary();
				updateUnlockAllButton();
			}
		}, function failed(response) {
			if (handledErrorCodes.indexOf(response.status) > -1) {
				if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
					$location.url(DX_URLS.get("overview"));
				} else {
					if (response.status === 403) {
						self.forbidden = true;
					}
					dxRavenInterceptor.logRejection(response);
				}
			}
		});
	}

	function handleRedactedPiiStudents() {
		self.studentProgress.forEach(function foreachStudentProgress(student) {
			if (student.redactedPii) {
				student.firstName = dxLocalize.get("RedactedPii.StudentName");
				student.lastName = "";
				student.studentCode = "";
				student.email = "";
			}
		});
	}

	function updateUnlockAllButton() {
		if (!self.filteredProgress.length) {
			return;
		}

		var firstIsOpen = self.filteredProgress[0].isOpen;
		for (var i = 1; i < self.filteredProgress.length; i++) {
			if (self.filteredProgress[i].isOpen !== firstIsOpen) {
				return;
			}
		}

		self.unlockAllToggle = !firstIsOpen;
	}

	$scope.$on("$destroy", function destroy() {
		$interval.cancel(self.updateProgressInterval);
		$interval.cancel(self.updateTimerInterval);
	});

	// Copies a student progress array to the scope property by property.
	// This to prevent redraw of the full ng-repeat
	self.copyStudentProgress = function copyStudentProgress(newProgress) {
		for (var j = 0; j < newProgress.length; j++) {
			var n = newProgress[j];
			var found = false;
			for (var i = 0; i < self.studentProgress.length; i++) {
				var o = self.studentProgress[i];
				if (n.id === o.id) {
					// Copy property by property to prevent full rerender of the ng-repeat
					for (var key in n) {
						if (n.hasOwnProperty(key)) {
							o[key] = n[key];
						}
					}
					found = true;
					break;
				}
			}

			if (!found) {
				self.studentProgress.push(n);
			}
		}
	};

	// Amount of students that have started the exam.
	self.hasOpenedCount = function hasOpenedCount() {
		if (self.studentProgress === null || typeof self.studentProgress === "undefined") {
			return 0;
		}

		var count = 0;
		for (var i = 0; i < self.studentProgress.length; i++) {
			var progress = self.studentProgress[i];
			var c = self.getExamClass(progress);

			switch (c) {
				case "color-active":
					++count;
					break;
				case "color-offline":
					++count;
					break;
				default:
					break;
			}
		}

		return count;
	};

	// Amount of students that have finished the exam.
	self.hasFinishedCount = function hasFinishedCount() {
		if (self.studentProgress === null || typeof self.studentProgress === "undefined") {
			return 0;
		}

		var count = 0;
		for (var i = 0; i < self.studentProgress.length; i++) {
			var progress = self.studentProgress[i];
			if (progress.isDone) {
				++count;
			}
		}

		return count;
	};

	self.openOrCloseAll = function openOrCloseAll() {
		var settingsToUpdate = [];
		var progressToOpen = {};

		for (var i = 0; i < self.studentProgress.length; i++) {
			var progress = self.studentProgress[i];

			if (progress.isOpen !== self.unlockAllToggle) {
				settingsToUpdate.push({
					studentId: progress.id,
					open: self.unlockAllToggle,
				});

				progressToOpen[progress.id] = progress;
			}
		}

		function dialogConfirm() {
			dxDialog.closeMostRecent();
			updateStudentSettings(settingsToUpdate);
		}

		if (settingsToUpdate.length) {
			dxDialog.confirm({
				title: dxLocalize.get(self.unlockAllToggle ? "LiveView.UnlockAll" : "LiveView.LockAll"),
				body: dxLocalize.get(self.unlockAllToggle ? "LiveView.UnlockAll.Question" : "LiveView.LockAll.Question"),
				acceptText: dxLocalize.get("Yes"),
				acceptCallback: dialogConfirm,
				rejectText: dxLocalize.get("No"),
			});
		}
	};

	self.openOrCloseExam = function openOrCloseExam(progress) {
		function dialogConfirm() {
			dxDialog.closeMostRecent();
			updateStudentSettings([{studentId: progress.id, open: !progress.isOpen}]);
		}

		dxDialog.confirm({
			title: dxLocalize.get(progress.isOpen ? "LiveView.LockExam" : "LiveView.UnlockExam"),
			body: dxLocalize.get(progress.isOpen ? "LiveView.LockExam.Question" : "LiveView.UnlockExam.Question"),
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: dialogConfirm,
			rejectText: dxLocalize.get("No"),
		});
	};

	function updateStudentSettings(settingsToUpdate) {
		dxApi.v1.exams.settings.put(self.exam.id, settingsToUpdate).then(function onResolve() {
			for (var i = 0; i < settingsToUpdate.length; i++) {
				for (var j = 0; j < self.filteredProgress.length; j++) {
					var updatedSettings = settingsToUpdate[i];
					var studentProgress = self.filteredProgress[j];

					if (updatedSettings.studentId === studentProgress.id) {
						studentProgress.isOpen = updatedSettings.open;
						break;
					}
				}
			}

			updateUnlockAllButton();
		}, function onFail(response) {
			if (response.status === 403 && self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
				$location.url(DX_URLS.get("overview"));
			}
		});
	}

	self.startExam = function startExam() {
		dxDialog.closeMostRecent();
		self.exam.startExam().then(function success() {
			$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.ongoing, self.exam.id));
		});
	};

	self.openEndExamDialog = function openEndExamDialog() {
		var scope = $rootScope.$new();
		scope.stopExam = self.stopExam;
		scope.studentSummary = self.studentSummary;
		scope.noStudentHasStarted = self.noStudentHasStarted;
		scope.isGroupExam = self.isGroupExam;

		scope.closeEndExamDialog = function closeEndExamDialog() {
			dxDialog.closeMostRecent();
		};

		dxDialog.show({
			templateUrl: "tmpl/exams/end-exam.html",
			$scope: scope,
		});
	};


	self.goToGrading = function goToGrading() {
		$location.path(DX_URLS.get("examGrading", {id: self.exam.id}));
		var scope = $rootScope.$new();

		dxDialog.show({
			templateUrl: "/partials/popups/monitor-exam-info.html",
			$scope: scope,
		});
	};

	self.openConfirmStartDialog = function openConfirmStartDialog() {
		dxDialog.confirm({
			title: dxLocalize.get("StartExam"),
			body: dxLocalize.get("DoYouWantToStartTheExam", self.exam.title),
			acceptText: dxLocalize.get("YesStartExam"),
			rejectText: dxLocalize.get("Cancel"),
			acceptCallback: self.startExam,
		});
	};

	self.stopExam = function stopExam() {
		dxDialog.closeMostRecent();

		var promise = self.exam.stopExam();

		return promise.then(function success(response) {
			if (response.exam) {
				var ex = new Exam(response.exam);
				ExamRepository.cache(ex);

				var queryString = "";
				switch (ex.examStatus) {
					case examStatus.NOT_STARTED:
					case examStatus.PLANNED:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.scheduled, self.exam.id);
						break;
					case examStatus.GRADED:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.graded, self.exam.id);
						break;
					default:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.ungraded, self.exam.id);
				}

				$location.url(DX_URLS.get("exams") + queryString);
			} else {
				// delete from ExamRepository
				for (var i = 0; i < ExamRepository.exams.length; i++) {
					var e = ExamRepository.exams[i];

					if (e.id === self.exam.id) {
						ExamRepository.exams.splice(i, 1);
						break;
					}
				}

				if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
					$location.url(DX_URLS.get("overview"));
				} else {
					$location.url(DX_URLS.get("exams"));
				}
			}
		});
	};

	// Some kind of safe array length function?
	self.length = function length(arr) {
		if (arr === null || typeof arr === "undefined") {
			return 0;
		}

		return arr.length;
	};

	// Changes the active tab on the view
	self.activeTab = "students";

	self.showTab = function showTab(tab) { // eslint-disable-line consistent-return
		if (self.activeTab === tab) {
			return false;
		}

		self.activeTab = tab;
	};

	// Shows the upload offline file dialog.
	self.uploadOfflineFile = function uploadOfflineFile() {
		var scope = $rootScope.$new();
		scope.examId = self.exam.id;
		scope.node = self.node;
		scope.onClose = updateProgress;

		dxDialog.show({
			templateUrl: "partials/popups/upload-offline-answer-file.html",
			$scope: scope,
		});
	};

	self.isPlanned = function isPlanned() {
		return self.exam && self.exam.examStatus === examStatus.PLANNED;
	};

	self.isActive = function isActive() {
		return self.exam && self.exam.examStatus === examStatus.ACTIVE;
	};

	self.hasEnded = function hasEnded() {
		return self.exam && (self.exam.examStatus >= examStatus.NOT_GRADED);
	};

	// Sets a flag on the exam
	self.setFlag = function setFlag(progress, newFlag) {
		var promise = dxExam.setFlags(progress.id, self.exam.id, newFlag);
		promise.then(function success() {
			progress.flags = newFlag;
			progress.isOpen = newFlag === settingFlags.NONE;
		});
	};

	// Clear exams flags
	self.markAsNotStarted = function markAsNotStarted(progress) {
		return self.setFlag(progress, settingFlags.NONE);
	};

	// Mark the exam as it was started offline.
	self.markAsOffline = function markAsOffline(progress) {
		return self.setFlag(progress, settingFlags.OFFLINE_START);
	};

	// Mark the exam as traditional, written with pen and paper
	self.markAsTraditional = function markAsTraditional(progress) {
		return self.setFlag(progress, settingFlags.TRADITIONAL_EXAM);
	};

	// Mark the exam as traditional, written with pen and paper
	self.markAsAbsent = function markAsAbsent(progress) {
		return self.setFlag(progress, settingFlags.STUDENT_ABSENT);
	};

	// Returns the text for the started column
	self.startedText = function startedText(progress) {
		var started = new Date(progress.started);

		if (!DX.isNullDate(started)) { // eslint-disable-line no-undef
			return $filter("date")(started, "HH:mm");
		}

		return "----";
	};

	self.studentStatusText = function studentStatusText(progress) {
		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return dxLocalize.get("Absent");
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0) {
			return dxLocalize.get("Offline");
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return dxLocalize.get("PenAndPaper");
		}

		return dxLocalize.get("NotStarted");
	};

	// Returns the text for the last updated column
	self.updatedText = function updatedText(progress) {
		var lastUpdate = new Date(progress.lastUpdate);
		if (!DX.isNullDate(lastUpdate)) { // eslint-disable-line no-undef
			return $filter("date")(lastUpdate, "yyyy-MM-dd HH:mm");
		}
		return "----";
	};

	// Return the text for the stopped column
	self.stoppedText = function stoppedText(progress) {
		var stopped = new Date(progress.stopped);
		var lastOfflineUpload = new Date(progress.lastOfflineUploadTime);
		if (!DX.isNullDate(stopped) && lastOfflineUpload <= stopped) { // eslint-disable-line no-undef
			return $filter("date")(stopped, "yyyy-MM-dd HH:mm");
		}

		if (!DX.isNullDate(lastOfflineUpload)) { // eslint-disable-line no-undef
			return dxLocalize.get("Offline");
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0 && new Date(progress.started).getFullYear() === 1) {
			return dxLocalize.get("NotDigitally");
		}

		return "----";
	};

	function getStudentStatus(progress) {
		if (!DX.isNullDate(progress.started)) { // eslint-disable-line no-undef
			if (self.isExamTimedOut(progress)) {
				return "offline";
			}

			return "active";
		}

		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return "absent";
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return "traditional";
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0 || !DX.isNullDate(progress.lastOfflineUploadTime)) { // eslint-disable-line no-undef
			return "offline";
		}

		return "idle";
	}

	self.getExamClass = function getExamClass(progress) {
		return "color-" + getStudentStatus(progress);
	};

	self.studentProgressSort = function studentProgressSort(progress) {
		if (!DX.isNullDate(progress.started)) { // eslint-disable-line no-undef
			return 0;
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0) {
			return 1;
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return 3;
		}

		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return 4;
		}

		return 2;
	};

	self.filterStudent = function filterStudent(progress) {
		var hits = [];
		var textFilter = self.studentFilter.text;
		var statusFilter = self.studentFilter.status;

		if (textFilter && textFilter.length > 0) {
			if (progress.firstName.toLowerCase().indexOf(textFilter.toLowerCase()) > -1) {
				hits.push(true);
			} else if (progress.lastName.toLowerCase().indexOf(textFilter.toLowerCase()) > -1) {
				hits.push(true);
			} else if (!self.node.disabledStudentCodes && progress.studentCode.toLowerCase().indexOf(textFilter.toLowerCase()) > -1) {
				hits.push(true);
			} else {
				hits.push(false);
			}
		}

		if (statusFilter !== null) {
			hits.push(statusFilter === getStudentStatus(progress));
		}

		return hits.indexOf(false) === -1;
	};

	self.onTableRowKeyDown = function onTableRowKeyDown(event, id) {
		if (event.keyCode !== DX_KEY_CODES.enter && event.keyCode !== DX_KEY_CODES.space) {
			return;
		}

		self.showStudent(id);
	};

	self.showStudent = function showStudent(id) {
		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			return;
		}

		$location.path(self.Urls.get("student", {id: id}));
	};

	self.studentHover = function studentHover(hoverEvent, hover) {
		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			return;
		}

		var studentInformationRow = hoverEvent.target.parentElement.getElementsByClassName("studentInformation");
		for (var i = 0; i < studentInformationRow.length; i++) {
			if (hover) {
				studentInformationRow[i].classList.add("studentHover");
			} else {
				studentInformationRow[i].classList.remove("studentHover");
			}
		}
	};

	self.studentFilterTextChanged = function studentFilterTextChanged() {
		$timeout(updateUnlockAllButton);
	};

	self.toggleStatusFilter = function toggleStatusFilter(filter) {
		if (self.studentFilter.status === filter) {
			self.studentFilter.status = null;
			return;
		}

		self.studentFilter.status = filter;

		$timeout(updateUnlockAllButton);
	};

	self.clearFilters = function clearFilters() {
		self.studentFilter.status = null;
		self.studentFilter.text = "";

		$timeout(updateUnlockAllButton);
	};

	// We have a stopped date, the answers are in and therefore cant be timed out
	self.isExamTimedOut = function isExamTimedOut(progress) {
		if (!DX.isNullDate(progress.stopped)) { // eslint-disable-line no-undef
			return false;
		}

		// The exam is not started, then it cant be timed out
		var timeout = new Date(progress.started);
		if (DX.isNullDate(timeout)) { // eslint-disable-line no-undef
			return false;
		}

		// If we have lastUpdate, use that as timeout instead of started
		if (!DX.isNullDate(progress.lastUpdate)) { // eslint-disable-line no-undef
			timeout = new Date(progress.lastUpdate);
		}

		// Timeout
		var fiveMinutes = 1000 * 60 * 5;
		timeout.setTime(timeout.getTime() + fiveMinutes);
		var now = new Date();
		return timeout < now;
	};

	self.noStudentHasStarted = function noStudentHasStarted() {
		var s = self.studentSummary || {};
		return s.activeCount + s.activeDoneCount + s.offlineCount + s.offlineDoneCount === 0;
	};

	self.isGroupExam = function isGroupExam() {
		return self.exam.isGroupExam();
	};

	self.isSettingEnabled = function isSettingEnabled(setting) {
		if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
			return (self.exam.invigilatorSettings & setting);
		}
		return true;
	};

	function getInvigilatorSettings() {
		dxApi.v1.exams.shares.data.get().then(function addInvigilatorSettings(response) {
			var shareData = response.data;
			var shareNotFound = true;
			for (var i = 0; i < shareData.length; i++) {
				if (shareData[i].objectId === self.exam.id) {
					self.exam.invigilatorSettings = shareData[i].data[0];
					shareNotFound = false;
					break;
				}
			}

			if (shareNotFound) {
				self.exam.invigilatorSettings = DX_INVIGILATOR_SETTINGS.NONE;
			}
		}, function onGetSettingsError() {
			self.exam.invigilatorSettings = DX_INVIGILATOR_SETTINGS.NONE;
		});
	}

	if (examId !== 0) {
		ExamRepository.load(examId).then(function success(loadedExam) {
			self.reqs.exam = true;
			self.exam = loadedExam;
			self.examStartMonth = $filter("date")(self.exam.start, "M");
			self.examStopMonth = $filter("date")(self.exam.stop, "M");
			self.updateTimerText();
			self.updateTimerInterval = $interval(self.updateTimerText, 1000);
			self.updateLiveView();
			self.updateProgressInterval = $interval(self.updateLiveView, 20000);

			if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
				getInvigilatorSettings();
			}

			/*
			** Watch the status so we can update the progress right away when the exam
			** is started instead of waiting for the interval to do it.
			** TODO: Fix so there is no race condition and remove the timeout.
			** We're using a timeout because the database might not have finished
			** writing the progress if we fetch it right away after starting an exam.
			*/

			function timeoutCallback() {
				$timeout(self.updateLiveView, 1000);
			}

			$scope.$watch("vm.exam.status", timeoutCallback, true);
		}, function failed() {
			self.forbidden = true;
		});
	}
});
